import { ErrorBoundary } from "@sentry/react";
import React, { useContext } from "react";
import "../../assets/styles/component/documentation.scss";
import { PasswordResetContext } from "../../context";
import { ErrorMsg } from "../AppMessages";
import { SetPasswordForm } from "../Forms";

export const PasswordReset = () => {
  const { showResetModal, token } = useContext(PasswordResetContext);

  return (
    <ErrorBoundary fallback={<ErrorMsg class={"formError"} />}>
      <div className={`popup ${showResetModal ? "show" : ""}`}>
        <div className="popupModal withForm">
          {/* This component is mounted unconditionally on every iframe/dashboard page
              (IframePageContent.tsx) as well as on /welcome, not just an actual password-reset
              flow - only ever CSS-hiding it via the "show" class above (not gating the mount
              itself) meant SetPasswordForm - and its own check-token-validity request - fired on
              essentially every ordinary page load, using this context's default token: "" until a
              real reset flow explicitly sets it. Only mounting it once a reset is actually active
              avoids that entirely, on top of SetPasswordForm's own now-added empty-token guard. */}
          {showResetModal && <SetPasswordForm token={token} />}
        </div>
      </div>
    </ErrorBoundary>
  );
};
